.vs-card-legend {
  display: inline-block;
  float: left;
}

.vs-card-field {
  margin-block-start: 1em;
  margin-block-end: 1em;
}

/* START GENAI@CHATGPT4 */
.vs-card-fieldset {
  display: flex;
  flex-direction: column;
}

/* END GENAI@CHATGPT4 */
